import jwtDecode from "jwt-decode";

const TOKEN_KEY = "token";

export const getToken = () => {
  try {
    const sessionToken = sessionStorage.getItem(TOKEN_KEY);
    if (sessionToken && sessionToken !== "undefined") {
      // Ensure existing logged-in sessions also persist across tabs/windows.
      localStorage.setItem(TOKEN_KEY, sessionToken);
      return sessionToken;
    }
  } catch (_err) {
    // ignore
  }

  // Legacy fallback + migration from localStorage to sessionStorage
  try {
    const legacyToken = localStorage.getItem(TOKEN_KEY);
    if (legacyToken && legacyToken !== "undefined") {
      sessionStorage.setItem(TOKEN_KEY, legacyToken);
      return legacyToken;
    }
  } catch (_err) {
    // ignore
  }

  return null;
};
 
export const setToken = (token) => {
  try {
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
      // Persist to localStorage too so auth survives tab/window changes.
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch (_err) {
    // ignore storage failures
  }
};

export const getDecodedToken = () => {
  const token = getToken();
  try {
    return token ? jwtDecode(token) : null;
  } catch (err) {
    console.error("Invalid token", err);
    return null;
  }
};
export function getSafeReturnTo(raw) {
  if (!raw) return null;

  try {
    // Support absolute or relative values. Enforce same origin.
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin) return null; // prevent open redirect
    // Keep only the path + query + hash
    return url.pathname + url.search + url.hash;
  } catch {
    // If it's a plain relative path like "/x", accept it; otherwise drop it
    return raw.startsWith("/") ? raw : null;
  }
}
